import {useEffect} from 'react';
import {useHistory} from 'helpers';

export function Home() {
  const history = useHistory();
  useEffect(() => {
    history.replace('./add/');
  }, []);
  return null;
}
